<style scoped>
/* Brand Colors */
.text-brand-purple { color: #1a1a40; }
.text-brand-gold { color: #c5a059; }
.bg-brand-purple { background-color: #1a1a40; }
.bg-brand-gold { background-color: #c5a059; }
.bg-brand-dark { background-color: #0f0f1a; }
.hover\:bg-brand-dark:hover { background-color: #0f0f1a; }
.hover\:text-brand-gold:hover { color: #c5a059; }

/* Layout & Spacing */
.home-container {
  font-family: 'Lato', sans-serif;
  color: #1a1a40;
}




/* ... */
/* Hero Section */
.hero-content {
  position: relative;
  z-index: 10;
  width: 100%;
  padding: 0 2rem; /* Consistent padding */
  display: flex;
  flex-direction: column;
  gap: 3rem;
  align-items: center;
  text-align: center;
  justify-content: center;
}

@media (min-width: 1024px) {
  .hero-content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 2rem;
  }
}
/* Hero Section Styles */
.hero-section {
  position: relative;
  width: 100%;
  min-height: 85vh;
  display: flex;
  align-items: center;
  background-color: #fff;
  overflow: hidden;
  padding-top: 0px;
}

.hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  background: radial-gradient(circle at 10% 20%, rgba(197, 160, 89, 0.05) 0%, transparent 40%),
              radial-gradient(circle at 90% 80%, rgba(26, 26, 64, 0.05) 0%, transparent 40%);
}

.hero-text {
  max-width: 600px;
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hero-subtitle {
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  text-transform: uppercase;
  color: #c5a059;
  letter-spacing: 0.2em;
  font-size: 0.875rem;
  margin-bottom: 1rem;
  display: block;
}

.hero-title {
  font-family: 'Playfair Display', serif;
  font-size: 4.5rem;
  font-weight: 900;
  color: #1a1a40;
  line-height: 1.05;
  margin-bottom: 0.5rem;
  letter-spacing: -0.02em;
  white-space: nowrap;
}

.hero-secondary-title {
  font-family: 'Lato', sans-serif;
  font-size: 1.5rem;
  font-weight: 300;
  color: #5a5a7a;
  margin-bottom: 2rem;
}

.divider {
  width: 80px;
  height: 4px;
  background-color: #c5a059;
  margin: 0 auto 2rem;
}

.hero-desc {
  font-family: 'Lato', sans-serif;
  font-size: 1.125rem;
  line-height: 1.7;
  color: #4a4a6a;
  margin-bottom: 2.5rem;
  max-width: 500px;
}

.btn-group {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.btn-solid {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.875rem 2.5rem;
  background-color: #1a1a40;
  color: #ffffff;
  text-decoration: none;
  font-weight: 600;
  letter-spacing: 0.05em;
  border-radius: 2px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #1a1a40;
  text-transform: uppercase;
  font-size: 0.875rem;
}

.btn-solid:hover {
  background-color: #2a2a55;
  border-color: #2a2a55;
  transform: translateY(-2px);
  box-shadow: 0 10px 20px -10px rgba(26, 26, 64, 0.3);
}

.btn-outline {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.875rem 2.5rem;
  background-color: transparent;
  color: #1a1a40;
  text-decoration: none;
  font-weight: 600;
  letter-spacing: 0.05em;
  border-radius: 2px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #1a1a40;
  text-transform: uppercase;
  font-size: 0.875rem;
}

.btn-outline:hover {
  background-color: #1a1a40;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 10px 20px -10px rgba(26, 26, 64, 0.2);
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .hero-title {
    font-size: 3.5rem;
  }
}

@media (max-width: 768px) {
  .hero-section {
    min-height: auto;
    padding-top: 100px;
    padding-bottom: 3rem;
  }
  
  .hero-content {
    align-items: center;
    text-align: center;
  }
  
  .hero-text {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .hero-title {
    font-size: 2.75rem;
  }
  
  .hero-secondary-title {
    font-size: 1.25rem;
  }
  
  .divider {
    margin-left: auto;
    margin-right: auto;
  }
  
  .hero-desc {
    font-size: 1rem;
    margin-bottom: 2rem;
  }
  
  .btn-group {
    justify-content: center;
    width: 100%;
  }
  
  .btn-solid, .btn-outline {
    width: 100%;
    max-width: 300px;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 2.0rem;
  }
}

/* Gallery Section */
.gallery-section {
  padding: 2rem;
  width: 100%;
  margin: 0;
}

/* CTA Section */
.cta-section {
  background-color: #1a1a40;
  color: white;
  padding: 5rem 1.5rem;
  text-align: center;
}

.cta-content {
  max-width: 800px;
  margin: 0 auto;
}

.cta-title {
  font-family: 'Playfair Display', serif;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.2;
}

.cta-subtitle {
  color: #c5a059;
  font-family: 'Lato', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  font-size: 0.9rem;
  margin-bottom: 2.5rem;
  font-weight: 600;
}




.social-links {
  display: flex;
  gap: 2rem;
  align-items: center;
  justify-content: center;
}

.social-icon {
  opacity: 0.7;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-icon:hover {
  opacity: 1;
  transform: translateY(-3px);
}

@media (max-width: 768px) {
  .cta-title {
    font-size: 2rem;
  }
  
  .footer-inner {
    flex-direction: column;
    text-align: center;
  }
}
</style>

<template>
  <div class="home-container">


    <!-- Hero Section -->
    <section class="hero-section">
      <div class="hero-bg">
        <!-- Optional: Background Image -->
        <!-- <img src="/assets/background.jpg" alt="Background patterns"> -->
      </div>
      
      <div class="hero-content">
        <div class="hero-text">
          <h2 class="hero-subtitle">Premium Paper Models</h2>
          <h1 class="hero-title">ORIGAMI SKIN</h1>
          <h3 class="hero-secondary-title">Realistic Fighter Jet Templates</h3>
          <div class="divider"></div>
          <p class="hero-desc">
            Discover the art of extreme paper folding. Download high-precision printable templates 
            to build your own F-16, F-18, F-22, Rafale, Mig-29 and other fighter jets. Designed for printed paper, 
            with selective cuts only when they improve form, reduce bulk, and bring the aircraft closer to reality.
          </p>
          <div class="btn-group">
            <a href="#gallery" class="btn-solid" @click.prevent="$vuetify.goTo('#gallery')">View Designs</a>
            <a href="https://store.origami-skin.com" class="btn-outline" @click="trackStore('hero')">Visit Store</a>
          </div>
        </div>
        

      </div>
    </section>

    <!-- Main Content -->
    <div> <!-- Removed fixed spacer as Hero handles it -->
      <!-- Gallery Section -->
      <main id="gallery" class="gallery-section">
        <!-- Existing Gallery Component -->
        <Gallery style="width: 100%" />
      </main>
    </div>

    <!-- CTA Section -->
    <section class="cta-section">
      <div class="cta-content">
        <h2 class="cta-title">An Epic Paper Fighter, Built by You</h2>
        <p class="cta-subtitle">Print it. Build it. Feel the Power.</p>
        
        <div class="social-links justify-center">
          <a href="https://www.instagram.com/origami.skin.q/" target="_blank" class="social-icon">
            <v-icon color="white" large>mdi-instagram</v-icon>
          </a>
          <a href="https://www.patreon.com/c/OrigamiSkin/home" target="_blank" class="social-icon" @click="trackPatreon('footer')">
             <img src="/assets/logo/patreon-icon.svg" alt="Patreon" style="width: 32px; height: 32px; object-fit: contain; filter: brightness(0) invert(1);">
          </a>
          <a href="https://www.youtube.com/@origami-skin" target="_blank" class="social-icon">
            <v-icon color="white" large>mdi-youtube</v-icon>
          </a>
        </div>
      </div>
    </section>



    <!-- Dialogs -->
    <v-row justify="center">
      <v-dialog
        v-if="editorDialog && !overlay"
        v-model="editorDialog"
        scrollable
        width="auto"
        persistent
        :fullscreen="$vuetify.breakpoint.xsOnly"
      >
        <v-card style="background-color: white">
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <Editor
              class="container"
              :analytics="analytics"
              :fighter="fighter"
              style="background-color: white"
              @close="$router.replace('/')"
            />
          </v-card-text>

          <v-card-actions class="justify-end" style="background-color: white">
            <div style="display: flex">
              <v-btn variant="outlined" @click="$router.replace('/')"
                >Close</v-btn
              >
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Privacy dialog -->
      <v-dialog
        v-if="privacyDialog && !overlay"
        v-model="privacyDialog"
        scrollable
        width="auto"
        persistent
        :fullscreen="$vuetify.breakpoint.xsOnly && isLoggedIn()"
      >
        <v-card style="background-color: #1a1a40; border: 1px solid rgba(197, 160, 89, 0.3);">
          <div style="background-color: #0f0f1a; padding: 20px 24px; border-bottom: 1px solid rgba(197, 160, 89, 0.2);">
            <h2 class="dialogTitle" style="font-family: 'Playfair Display', serif; color: #c5a059; font-size: 1.5rem; letter-spacing: 0.05em; margin: 0;">PRIVACY POLICY</h2>
          </div>
          
          <Privacy />
          
          <div style="background-color: #0f0f1a; padding: 16px 24px; border-top: 1px solid rgba(197, 160, 89, 0.2); display: flex; justify-content: flex-end;">
            <v-btn 
              text 
              color="#c5a059" 
              @click="$router.replace('/')"
              style="font-weight: 600; letter-spacing: 0.1em;"
            >
              Close
            </v-btn>
          </div>
        </v-card>
      </v-dialog>

      <!-- Gumroad License Modal -->
      <GumroadLicenseModal
        :visible="gumroadModal"
        :product-name="currentProductName"
        :product-permalink="currentPermalink"
        :product-id="currentProductId"
        @verified="onLicenseVerified"
        @verify-attempt="onVerifyAttempt"
        @close="closeGumroadModal"
      />
    </v-row>

    <v-overlay v-if="overlay" class="align-center justify-center">
      <v-progress-circular
        color="primary"
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

  </div>
</template>

<script>
"use strict";

import Editor from "@/components/Editor";
import Gallery from "@/components/Gallery";
import Privacy from "@/components/Privacy";
import GumroadLicenseModal from "@/components/GumroadLicenseModal";
// import Disqus from "@/components/Disqus";
import { findFighterDesign } from "@/data/fighterDesigns.js";
import * as firebase from "@/firebase.js";

export default {
  name: "Home",

  components: {
    Editor,
    Gallery,
    Privacy,
    GumroadLicenseModal,
    // Disqus,
  },

  data() {
    return {
      analytics: firebase.analytics,
      editorDialog: false,
      privacyDialog: false,
      fighter: null,
      authInfo: null,
      overlay: false,
      userId: null,
      // logoSvg: '/assets/logo/logo.svg' // Moved to App.vue
      gumroadModal: false,
      currentPermalink: "",
      currentProductId: "",
      currentProductName: "",
      pendingFighter: null,
    };
  },
  mounted() {
    firebase.addLoginCallback(this.onChangefirebaseInfo);
    this.onChangeRoute(this.$route);
  },
  methods: {
    onChangefirebaseInfo(authInfo) {
      this.authInfo = authInfo;
      if (authInfo == null) {
        console.log("onChangefirebaseInfo(null)");
      } else {
        console.log(
          `onChangefirebaseInfo(${JSON.stringify(authInfo.user.uid)})`,
        );
        firebase.setUser(authInfo.user.uid);
      }
      this.overlay = false;
    },
    isLoggedIn() {
      return this.authInfo != null;
    },

    // logoPath() Removed as we use static SVG now
    openEditorDialog(fighter) {
      this.fighter = fighter;
      this.editorDialog = true;
    },
    closeEditorDialog() {
      this.fighter = null;
      this.editorDialog = false;
    },
    openPrivacyDialog() {
      this.privacyDialog = true;
    },
    closePrivacyDialog() {
      this.privacyDialog = false;
    },
    getFighter(route) {
      if (route === undefined) {
        return null;
      } else {
        const fighter = route.params.fighter;
        const design = findFighterDesign(fighter);
        if (design == null) {
          return null;
        }
        return fighter;
      }
    },
    getPatreonUrl(fighter) {
      const design = findFighterDesign(fighter);
      if (design == null) {
        return null;
      }
      return design.patreonStoreLink;
    },
    onChangeRoute(route) {
      if (route.path === "/privacy") {
        this.openPrivacyDialog();
      } else if (route.path.startsWith("/fighters/")) {
        const fighter = this.getFighter(route);
        const patreonUrl = this.getPatreonUrl(fighter);
        if (patreonUrl) {
          window.location.href = patreonUrl;
          // window.history.back();
        } else if (fighter == null) {
          this.closeEditorDialog();
        } else {
          this.attemptOpenEditor(fighter);
        }
      } else {
        this.closeEditorDialog();
        this.closePrivacyDialog();
      }
    },
    attemptOpenEditor(fighter) {
      const design = findFighterDesign(fighter);
      if (design && design.gumroadPermalink) {
        const license = localStorage.getItem(
          `gumroad_license_${design.gumroadPermalink}`
        );
        if (!license) {
          this.pendingFighter = fighter;
          this.currentPermalink = design.gumroadPermalink;
          this.currentProductId = design.gumroadProductId || "";
          this.currentProductName = design.name;
          this.gumroadModal = true;
          
          if (this.analytics) {
            firebase.logEvent(this.analytics, 'gumroad_product_view', {
              product_name: design.name,
              permalink: design.gumroadPermalink
            });
          }
          return;
        }
      }
      this.openEditorDialog(fighter);
    },
    onLicenseVerified({ permalink }) {
      localStorage.setItem(`gumroad_license_${permalink}`, "true");
      
      if (this.analytics) {
        // Need to find the name since onLicenseVerified only passes permalink usually? 
        // Or we can rely on this.currentProductName which should be set.
        firebase.logEvent(this.analytics, 'gumroad_license_verified', {
          product_name: this.currentProductName,
          permalink: permalink
        });
      }

      if (this.pendingFighter) {
        this.openEditorDialog(this.pendingFighter);
        this.pendingFighter = null;
      }
    },
    closeGumroadModal() {
      // If pendingFighter is still set when closing, it means verification didn't happen (canceled)
      if (this.pendingFighter) {
         if (this.analytics) {
            firebase.logEvent(this.analytics, 'gumroad_license_canceled', {
               product_name: this.currentProductName,
               permalink: this.currentPermalink
            });
         }
      }

      this.gumroadModal = false;
      this.pendingFighter = null;
      this.$router.replace('/');
    },
    onVerifyAttempt() {
      if (this.analytics) {
        firebase.logEvent(this.analytics, 'gumroad_verify_clicked', {
           product_name: this.currentProductName,
           permalink: this.currentPermalink
        });
      }
    },
    trackPatreon(location) {
      if (this.analytics) {
        firebase.logEvent(this.analytics, 'click_patreon', { location });
      }
    },
    trackStore(location) {
      if (this.analytics) {
        firebase.logEvent(this.analytics, 'click_store', { location });
      }
    },
  },
  watch: {
    $route(route) {
      this.onChangeRoute(route);
    },
  },
};
</script>
